import { NgModule, Optional, SkipSelf } from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';

import { BlockingSpinnerService } from './blocking-spinner/blocking-spinner.service';
import { BlockingSpinnerComponent } from './blocking-spinner/blocking-spinner.component';

import { ModalRedirectToComponent } from './modal-redirect-to/modal-redirect-to.component';
import { ModalRedirectToService } from './modal-redirect-to/modal-redirect-to.service';

import { AuthenticationService } from './authentication/authentication.service';

import { AcessibilidadeService } from './acessibilidade/acessibilidade.service';
import { BarraAcessibilidadeComponent } from './acessibilidade/barra-acessibilidade/barra-acessibilidade.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  declarations: [
    BlockingSpinnerComponent,
    ModalRedirectToComponent,
    BarraAcessibilidadeComponent,
  ],
  exports: [
    BlockingSpinnerComponent,
    ModalRedirectToComponent,
    BarraAcessibilidadeComponent,
  ],
  providers: [
    BlockingSpinnerService,
    ModalRedirectToService,
    AuthenticationService,
    AcessibilidadeService,
  ],
})
export class CoreModule {

  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
